import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Prescribir sin ficha técnica validada',
    cost: 'Inseguridad clínica que el paciente percibe'
  }, {
    without: 'Sin semáforo de seguridad por planta',
    cost: 'Riesgo real de indicar algo contraindicado'
  }, {
    without: 'Sin tabla de interacciones',
    cost: 'Paciente medicado en riesgo sin saberlo'
  }, {
    without: 'Sin protocolo por sistema',
    cost: 'Armás cada sesión desde cero, sin estructura'
  }, {
    without: 'Sin recetario de fórmulas',
    cost: 'Combinaciones improvisadas sin respaldo'
  }, {
    without: 'Sin dosificación pediátrica',
    cost: 'No sabés cómo ajustar para niños o adultos mayores'
  }, {
    without: 'Sin criterios de derivación',
    cost: 'No sabés cuándo la fitoterapia no alcanza'
  }, {
    without: 'Sin ficha de consultorio',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin guía de proveedores',
    cost: 'Materia prima de calidad desconocida'
  }, {
    without: 'Sin espagiria vegetal',
    cost: 'Perdés pacientes que buscan preparaciones avanzadas'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de incertidumbre, la próxima semana'
  }];
  return <Section data-id="element-17" data-mp="21mjpy2ba4cqt">
      <div className="text-center mb-12" data-id="element-18" data-mp="21lqpfj2wyjh4">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-purpleDark" data-id="element-19" data-mp="21kyv0bl1yrsf">
          <span className="mr-3" data-id="element-20" data-mp="1smn6cf3qy42m">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-21" data-mp="1xkyemlee86iq">
        <div className="hidden md:block" data-id="element-22" data-mp="1xlq196q0itwv">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-23" data-mp="1inxlqekgu5io">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-24" data-mp="1ioh4fxhxwxxr">
              Sin Kit Saberes Ancestrales
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-25" data-mp="14if878spwkf0">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-26" data-mp="zqnq7mnmnn0h">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-27" data-mp="us2rjro0xbe5" data-mpi={i}>
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-28" data-mp="1ngzwyu74zdph">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-29" data-mp="1ij84nz2kxpkr">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-30" data-mp="18ksb7pg2y483">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-31" data-mp="23oo2we61mv7" data-mpi={i}>
              <p className="text-sm font-medium text-brand-text" data-id="element-32" data-mp="3t8wx2ha4af51">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-33" data-mp="28q4bfabd9emz">
                <span className="text-brand-burgundy shrink-0" data-id="element-34" data-mp="2dp7fosjivgtw">→</span>
                <span className="text-sm" data-id="element-35" data-mp="2ipldzivbnceq">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-16" data-id="element-36" data-mp="2niwlznbvdz88">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-purpleDark" data-id="element-37" data-mp="2sgy2q1ltpmgj">
          "El terapeuta que tiene un sistema, aplica con confianza. El que
          aplica con confianza, genera resultados. El que genera resultados,
          crece." 🌿
        </p>
      </div>
    </Section>;
};